<template>
    <item-list-and-component
            :value="value"
            label=""
            :label-property="'name'"
            component="RepositoryFilePicker"
            :component-props="componentProps"
            v-on:input="$emit('input', $event)"
            :value-contains-objects="true"
    ></item-list-and-component>

</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            value: {type: Array},
            repository: {type: Object},
            operationsUrl: {type: String},
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        methods: {},
        computed: {
            componentProps: function() {
                return {
                    repository: this.repository,
                    operationsUrl: this.operationsUrl,
                    basename: true,
                    valueset: this.value,
                }
            }
        },
        watch: {}

    }
</script>
